module.exports = __webpack_public_path__ + "static/img/3.9cc2331.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/icon/3.png
// module id = CBci
// module chunks = 1